import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="footer-section">
          <h4>About</h4>

          <Link to="/about" onClick={toTop}>
            About us
          </Link>
        </div>
        <div className="footer-section">
          <h4>Help</h4>
          <Link to="/contact" onClick={toTop}>
            Customer Service
          </Link>
          <Link to="/shipping" onClick={toTop}>
            Shipping
          </Link>
          <Link to="/returns" onClick={toTop}>
            Returns
          </Link>
          <Link to="/terms" onClick={toTop}>
            Terms
          </Link>
          <Link to="/privacy" onClick={toTop}>
            Privacy
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Cookies
          </Link>
          <Link to="/faqs" onClick={toTop}>
            FAQs
          </Link>
        </div>
        <div className="footer-section">
          <div className="store">
            <h5>Customer service</h5>
            <p>
              round@pittleforestandco.shop
              <br />
              19 Westmount Rd, Corner Brook, NL A2H 5R3 Canada
              <br />
              Mon - Fri, 9am - 3pm
            </p>
          </div>
        </div>
        <div className="footer-section">
          <p className="copyright">© pittleforestandco 2026</p>

          <h4>Always stationery, never stationary.</h4>
          <p className="footer-text">
            Discover thoughtful stationery at pittleforestandco. Browse our
            diaries, notebooks, pens, pencils and more at our stationery shops.
            Visit our London and Brighton shops, or explore our considered
            collection online.
          </p>
        </div>
      </div>

      <div className="footer-payments">
        <div className="payment-icons">
          <svg
            className="payment-icon"
            width="40"
            height="25"
            viewBox="0 0 40 25"
          >
            <rect x="2" y="2" width="36" height="21" rx="3" fill="#016FD9" />
            <text
              x="20"
              y="16"
              textAnchor="middle"
              fill="white"
              fontSize="10"
              fontWeight="bold"
            >
              AMEX
            </text>
          </svg>
          <svg
            className="payment-icon"
            width="40"
            height="25"
            viewBox="0 0 40 25"
          >
            <rect x="2" y="2" width="36" height="21" rx="3" fill="#1A1F71" />
            <text
              x="20"
              y="16"
              textAnchor="middle"
              fill="white"
              fontSize="10"
              fontWeight="bold"
            >
              VISA
            </text>
          </svg>
          <svg
            className="payment-icon"
            width="40"
            height="25"
            viewBox="0 0 40 25"
          >
            <rect x="2" y="2" width="36" height="21" rx="3" fill="#003087" />
            <text
              x="20"
              y="16"
              textAnchor="middle"
              fill="white"
              fontSize="10"
              fontWeight="bold"
            >
              MC
            </text>
          </svg>
        </div>
        <p className="footer-copyright">© 2026, pittleforestandco</p>
      </div>
    </footer>
  );
}

export default Footer;
